export default {
  name: "AdvancedAnimation"
}
